export default function consoler() {
    console.log('tester')
};

export async function postData(url = "", data = {}) {
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
    });
    return response.json();
}

export function object2array(objecto)
{
  let datagridtmp=[];
  for(var mydata in objecto) {
      datagridtmp=[...datagridtmp,objecto[mydata]]
  }
  return datagridtmp;
}

export function vacio(texto)
{
    
    if(texto==null) return '<span class="text-secondary">[Vacio]</span>';
    if(texto.trim()=='')
    {
        return '<span class="text-secondary">[Vacio]</span>';
    } else {
        return texto;
    }
    
}

export function number(number)
{
    if(number===null) return 0;
    return parseInt(number);
}

export function moneda(number, moneda)
{
    if(number===null) return moneda+(0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    //return moneda+parseInt(number).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return moneda+parseFloat(number).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

/*
sleep(2000).then(() => { 
     colocar script
});*/

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}